import helper from '@/libs/forms';


export default {
  schema: (selectLabel, selectModel, selectMap, addLabel, onAddClicked) => ({
    fields: [
      {
        type: 'select',
        label: selectLabel,
        model: selectModel,
        selectOptions: {
          noneSelectedText: '-',
        },
        values: () => {
          const vals = [];
          Object.keys(selectMap).forEach((key) => {
            vals.push({ id: key, name: selectMap[key] });
          });

          return vals;
        },
        buttons: [
          {
            classes: 'field-add-btn',
            label: addLabel,
            onclick(model) {
              onAddClicked(model);
            },
          },
        ],
        styleClasses: 'col-md-12',
        validator: 'string',
      },
    ],
  }),
  formOptions: prefix => helper.options(prefix, true),
};



// WEBPACK FOOTER //
// ./src/components/utils/selects/select_button_form/schema.js